import { render, staticRenderFns } from "./CodiVerseNavbar.vue?vue&type=template&id=5e54e3f1&scoped=true&"
import script from "./CodiVerseNavbar.vue?vue&type=script&lang=js&"
export * from "./CodiVerseNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54e3f1",
  null
  
)

export default component.exports